module.exports = __webpack_public_path__ + "img/gold_level1.178e6040.png";